export const COVERAGE_EVENTS = {
    CHECK: 'ARTWORK_COVERAGE_CHECK',
    BLOCK_NEXT: 'ARTWORK_COVERAGE_BLOCK_NEXT',
    BG_ACTIVE: 'ARTWORK_COVERAGE_BG_ACTIVE',
    CLEAR: 'ARTWORK_COVERAGE_CLEAR',
}
